import { BrowserRouter as Router } from "react-router-dom";
import {  Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import RouteConfig from "./routes/RouteConfig";
import "./App.css";

function App() {
  return (

    <HelmetProvider>
      <Router>
        <div className="App">
          <RouteConfig />
        </div>
      </Router>
    </HelmetProvider>

    
  );
}

export default App;
